



















import { Component, Prop, Vue } from "vue-property-decorator";
//  components
//  types

@Component({})
export default class Tooltip extends Vue {
  @Prop({ required: true, type: String }) text!: string;

//  @Getters

//  @Methods
}
